/**
 * Extract devis information from a file using OCR + AI
 * @param {File|Blob} file - The file to extract information from
 * @param {string} token - Authentication token
 * @param {string} prefix - API URL prefix
 * @returns {Promise<object>} Extracted devis information
 */
export default async function extractDevisInfosFromFile(file, token, prefix) {
  try {
    const formData = new FormData();

    if (file instanceof File) {
      formData.append("file", file);
    } else if (file instanceof Blob) {
      formData.append("file", file, "document.pdf");
    } else if (typeof file === "string") {
      const fileResponse = await fetch(file);
      if (!fileResponse.ok) {
        throw new Error(`Failed to download file: ${fileResponse.status}`);
      }
      const fileBlob = await fileResponse.blob();
      const fileName =
        file.split("/").pop().replace(/\s+/g, "_") || "document.pdf";
      formData.append("file", fileBlob, fileName);
    } else {
      throw new Error("Invalid file format");
    }

    const url = `${prefix}extract/devis`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (response.ok) {
      const extractedData = await response.json();
      console.log("Extracted devis information:", extractedData);
      return extractedData;
    } else {
      const errorText = await response.text();
      console.error(`Devis extraction failed: ${response.status} - ${errorText}`);
      throw new Error(`Extraction failed: ${response.status}`);
    }
  } catch (error) {
    console.error(`Error extracting devis information: ${error.message}`);
    throw error;
  }
}
